<template>
  <div class="verify-check-container">
    <div class="verify-token-input">
      <input
        v-model="manualToken"
        type="text"
        class="form-control"
        placeholder="Cole o token aqui..."
      >
      <button
        class="btn btn-primary"
        :disabled="!manualToken"
        @click="verifyManualToken"
      >
        Verificar
      </button>
    </div>
    <div
      v-if="loading"
      class="verify-loading"
    >
      Carregando...
    </div>
    <div
      v-else-if="error"
      class="verify-error"
    >
      {{ error }}
    </div>
    <div
      v-else-if="check"
      class="verify-success"
    >
      <h2>Confirmação de Ponto</h2>
      <p><strong>Nome:</strong> {{ user ? user.name : check.user_id }}</p>
      <p><strong>Data/Hora:</strong> {{ formatDate(check.created_at) }}</p>
      <p><strong>Tipo:</strong> {{ check.remote ? 'Remoto' : 'Presencial' }}</p>
    </div>
    <div
      v-else
      class="verify-empty"
    >
      Nenhum dado encontrado.
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VerifyCheck',
  data() {
    return {
      loading: false,
      error: '',
      check: null,
      user: null,
      manualToken: '',
    }
  },
  watch: {
    '$route.params.token': {
      handler(token) {
        if (!token) return
        this.manualToken = token
        this.verifyManualToken()
      },
    },
  },
  mounted() {
    const { token } = this.$route.params
    if (token) {
      this.manualToken = token
      this.verifyManualToken()
    }
  },
  methods: {
    async verifyManualToken() {
      if (!this.manualToken) return
      this.loading = true
      this.error = ''
      this.check = null
      this.user = null
      const api = `${this.$store.state.api}check/verify/${this.manualToken}`
      try {
        const response = await fetch(api)
        const data = await response.json()
        if (data.status === 'success') {
          this.check = data.data
          if (this.check && this.check.user_id) {
            const userApi = `${this.$store.state.api}users/${this.check.user_id}`
            const token = localStorage.getItem('token')
            try {
              const userRes = await fetch(userApi, {
                headers: {
                  Authorization: token ? `Bearer ${token}` : '',
                },
              })
              const userData = await userRes.json()
              if (userData && userData.data && userData.data.length > 0) {
                this.user = userData.data[0]
              }
            } catch (e) {
              console.error('Erro ao buscar dados do usuário.', e)
            }
          }
        } else {
          this.error = data.message || 'Erro ao verificar ponto.'
        }
      } catch (e) {
        this.error = 'Erro ao consultar API.'
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('pt-BR')
    },
  },
}
</script>

<style scoped>
.verify-token-input {
  display: flex;
  gap: 8px;
  margin-bottom: 18px;
}
.verify-check-container {
  max-width: 420px;
  margin: 48px auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 32px 28px 24px 28px;
  font-family: 'Segoe UI', Arial, sans-serif;
}
.verify-loading, .verify-error, .verify-empty {
  text-align: center;
  color: #888;
  font-size: 1.1em;
}
.verify-success h2 {
  color: #2d7be5;
  margin-bottom: 18px;
}
.verify-success p {
  margin: 8px 0;
}
</style>
